<template>
  <div>
    <div class="card p-3 shadow-sm">
      <form @submit.prevent="">
        <div class="row justify-content-between">
          <div class="col-auto">
            <h5 class="e-text-red">
              Inspection
            </h5>
          </div>
          <div class="col-auto"
               v-if="isAllowed('psc.main.inspection.details.edit') && isOwnVessel('pscReport')">
            <template v-if="toEdit">
              <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelUpdate" v-if="toEdit">Cancel</button>
              <button class="e-btn e-btn-blue ml-2" :class="hasChanges === false ? 'e-btn-blue-disabled' : ''" type="button" @click="updatePsc" :disabled="hasChanges === false">Save</button>
            </template>
            <template v-else>
              <button class="e-btn e-btn-green ml-2 px-3" type="button" @click="editMainReport">Edit Inspection Details</button>
            </template>
          </div>
        </div>
        <table class="w-100">
          <tr>
            <td style="width: 25%">Name of Inspector <sub class="lead e-text-red font-weight-bold">*</sub></td>
            <td>
              <input type="text" v-if="toEdit" v-model="mainReport.inspection.inspector_name" class="form-control-sm form-control" name="inspection_inspector_name" id="inspection_inspector_name">
              <span v-else>{{ pscGet('inspection.inspector_name') | toUpper }}</span>
            </td>
          </tr>
          <tr>
            <td>Deficiencies <sub class="lead e-text-red font-weight-bold">*</sub></td>
            <td>
              <template v-if="!!mainReport.inspection && toEdit">
                <select class="form-control form-control-sm" v-model="mainReport.inspection.deficiencies" style="width: 150px;">
                  <option :value="true">YES</option>
                  <option :disabled="pscGet('psc_deficiencies')?.length > 0" :value="false">NO</option>
                </select>
              </template>
              <span v-else>{{pscGet('inspection.deficiencies') ? 'YES' : 'NO'}}</span>
            </td>
          </tr>
          <template v-if="!!mainReport.inspection">
            <tr v-if="!mainReport.inspection.deficiencies && toEdit">
              <td>Psc Bonus (USD)</td>
              <td>
                <input type="number" v-model="mainReport.inspection.bounty"
                       class="form-control form-control-sm" name="bounty"
                       id="bounty" step="0.01" min="0.00" style="width: 150px;">
              </td>
            </tr>
          </template>
          <template v-else>
            <tr v-if="!pscGet('inspection.deficiencies') && !toEdit">
              <td>Psc Bonus (USD)</td>
              <td>
                <span>{{ pscGet('inspection.bounty')}}</span>
              </td>
            </tr>
          </template>
          <tr>
            <td style="width: 25%">Detained <sub class="lead e-text-red font-weight-bold">*</sub></td>
            <td>
              <select v-if="toEdit" class="form-control form-control-sm" v-model="mainReport.inspection.detained" style="width: 150px;">
                <option :value="true">YES</option>
                <option :value="false">NO</option>
              </select>
              <span v-else>{{ pscGet('inspection.detained') | toYesOrNo | toUpper }}</span>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">Number of Deficiencies</td>
            <td>
              <span>{{ pscGet('psc_deficiencies')?.length }}</span>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="align-top">Inspection Outline <sub class="lead e-text-red font-weight-bold">*</sub></td>
            <td>
              <vue-editor v-if="toEdit" v-model="mainReport.inspection.outline" :editor-toolbar="toolbar" ></vue-editor>
              <div v-else id="textArea" class="pre-wrap-txt textarea-display-card my-2" v-html="pscGet('inspection.outline')"/>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">Attached PSC Report <sub class="lead e-text-red font-weight-bold">*</sub></td>
            <td>
              <template>
                <template>
                  <button class="e-btn e-btn-green mr-3"
                          @click="$refs.inspectionAttachments.click()"
                          v-if="toEdit && isAllowed('psc.main.inspection.attachments.create') && isOwnVessel('pscReport')"
                  >
                    Add Attachment
                  </button>
                  <button class="e-btn e-btn-blue"
                          @click="downloadAll(1,pscReport,'inspection.id')"
                          v-if="isAllowed('psc.main.inspection.attachments.download-all') && isOwnVessel('pscReport') && pscAttachments?.length"
                  >
                    Download All
                  </button>
                </template>
<!--                  <template v-if="toEdit">-->
                    <input style="visibility: hidden" type="file" class="w-75" ref="inspectionAttachments" multiple
                           @change="addAttachmentToInspection">
<!--                    <button class="e-btn e-btn-outlined-red" @click="cancelUpload">Cancel</button>-->
<!--                  </template>-->
              </template>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <psc-attachment :attachments="allAttachments"
                              :to-edit="toEdit"
                              style="height: 25vh;"
                              :type="1"
                              view-permission="psc.main.inspection.attachments.view-download"
                              download-permssion="psc.main.inspection.attachments.view-download"
                              delete-permission="psc.main.inspection.attachments.delete"
                              @deleteEmitter="deleteInspectionAttachments"

              >
              </psc-attachment>
            </td>
          </tr>
        </table>
      </form>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ObjectMixin from "../../../mixins/ObjectMixin";
import {AlertService} from "../../../services/AlertService";
import AttachmentMixin from "../../../mixins/attachmentMixin";
import {permissionMixin} from "@/mixins/permissionMixins";
import PscAttachment from "./PscAttachment.vue";
import {DataService} from "@/services/DataService";

export default {
  name: "PscInspection",
  data() {
    return {
      toEdit: false,
      toolbar:[
        ['bold','italic','strike','underline'],
        [{'color':["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]}]
      ],
      default: {
        mainReport: {
          id: parseInt(this.$route.params.id),
          inspection: {
            inspector_name: null,
            deficiencies: false,
            detained: false,
            deficiency_count: 0,
            outline: null,
            bounty:0,
          },
        },
      },
      mainReport: {},
      rankIdMaster: 1,
      rankIdCE: 2,
      crewLists: {},
      addAttachment:false,
      newAttachments : [],
      attachmentsToDelete : []
    }
  },
  mixins: [ObjectMixin,AttachmentMixin,permissionMixin],
  components:{PscAttachment},
  methods: {
    ...mapActions(['getPscReport', 'updatePscInfo','uploadPscAttachments']),
    async cancelUpdate(){
      if (this.hasChanges === false) {
        this.toEdit = false
        this.mainReport = this.default.mainReport;
      } else {
        if (await AlertService.cancelAlert()) {
          await this.resetFields()
        }
      }
    },
    async updatePsc() {
      if (await AlertService.confirmUpdateAlert("Do you want to update ? ")) {
        const response = await this.updatePscInfo(this.mainReport);
        await this.requestUploadNewAttachments();
        await this.requestDeleteAttachments();
        if (response) {
          AlertService.successAlert('PSC updated successfully', 'UPDATE PSC')
          await this.resetFields()
        }
      }
    },
    editMainReport() {
      this.toEdit = true;
      this.mainReport = {
        id: this.pscGet('id'),
        inspection: {
          inspector_name: this.pscGet('inspection.inspector_name'),
          deficiencies: !!this.pscGet('inspection.deficiencies'),
          detained: !!this.pscGet('inspection.detained'),
          deficiency_count: this.pscGet('inspection.deficiency_count'),
          outline: this.pscGet('inspection.outline'),
          bounty: this.pscGet('inspection.bounty'),
        }
      }
    },
    async resetFields() {
      this.toEdit = false
      this.mainReport = this.default.mainReport;
      this.newAttachments = [];
      this.attachmentsToDelete = [];
      await this.getAttachments(1, this.pscReport,'inspection.id')
      let params = {
        id: this.$route.params.id,
        activeModule : 'inspection'
      };
      await this.getPscReport(params);
    },
    async requestUploadNewAttachments() {
      let formData=new FormData();
      for (let counter = 0; counter < this.newAttachments.length; counter++) {
        formData.append('attachments[]',this.newAttachments[counter].file)
      }

      formData.append('id',this.pscGet('id'))
      formData.append('type[id]',this.pscGet('inspection.id'))
      formData.append('type[type_id]',1)
      const response =await this.uploadPscAttachments(formData);
      if(response){
        this.addAttachment=false;
      } else {
        AlertService.successAlert('There\s a problem adding attachments','Add Inspection Attachments')
      }
    },
    async requestDeleteAttachments() {
      for (let counter = 0; counter < this.attachmentsToDelete.length; counter++) {
        const file = this.attachmentsToDelete[counter].file
        const type = this.attachmentsToDelete[counter].type
        await this.deletePscAttachment({
          id : this.$route.params.id,
          type : {
            id : file.id,
            type_id : type
          }
        });
      }
    },

    async addAttachmentToInspection(){
      if(this.$refs.inspectionAttachments.files.length){
        let counter = 0;
        Array.prototype.forEach.call(this.$refs.inspectionAttachments.files,file=>{
          if ((file.size / 1024 / 1024) > 2.5) {
            AlertService.warningAlert('File size must not exceed 2.5 MB: ' + file.name, 'Add Inspection Attachments')
            return;
          }
          let fileType = DataService.checkFileType(file);
          let fileName = file.name.lastIndexOf('.') > -1 ? file.name.substring(0, file.name.lastIndexOf('.')) : file.name;
          this.newAttachments.push({
            extension : fileType,
            created_at : new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            file_size  : (file.size / 1024).toFixed(2) + ' KB',
            has_file   : false,
            id         : null,
            mime_type  : file.type,
            name       : fileName.toUpperCase(),
            thumbnail  : null,
            file_index : counter++,
            file       : file
          });
        })
      }
    },

    async cancelUpload() {
      if(await AlertService.cancelAlert()){
        this.$refs.inspectionAttachments.value=null;
        this.addAttachment=false;
      }
    },

    async deleteInspectionAttachments(attachment){
      if (attachment.attachment.id === null) {
        this.newAttachments =  this.newAttachments.filter(item => item.file_index !== attachment.attachment.file_index);
        return;
      }
      this.attachmentsToDelete.push({
        file : attachment.attachment,
        type : attachment.type
      })

      const pscAttachments = this.pscAttachments.filter(file => file.id !== attachment.attachment.id);
      this.$store.commit('SET_PSC_ATTACHMENTS', {
          type_id : attachment.type,
          attachments : pscAttachments
      })
    }

  },
  async beforeRouteLeave(to, from, next) {
    if (this.hasChanges === true) {
      if (await AlertService.cancelChanges()) {
        next();
      } else {
        next(false);
      }

    } else {
      next();
    }
  },
  computed: {
    ...mapGetters([
      'pscReport',
      'pscAttachments'
    ]),
    allAttachments() {
      return [...this.pscAttachments, ...this.newAttachments];
    },
    hasChanges() {
      if (this.toEdit === false) {
        return false;
      }

      let originalData = {
        inspector_name : this.pscReport.inspection.inspector_name,
        deficiencies   : this.pscReport.inspection.deficiencies,
        bounty         : this.pscReport.inspection.bounty,
        detained       : this.pscReport.inspection.detained,
        outline        : DataService.normalizeWhitespace(DataService.stripHtml(this.pscReport.inspection.outline)),
      }

      let editedData = {
        inspector_name : this.mainReport.inspection.inspector_name === '' ? null : this.mainReport.inspection.inspector_name,
        deficiencies   : this.mainReport.inspection.deficiencies,
        bounty         : this.mainReport.inspection.bounty === '' ? null : this.mainReport.inspection.bounty,
        detained       : this.mainReport.inspection.detained,
        outline        : DataService.normalizeWhitespace(DataService.stripHtml(this.mainReport.inspection.outline)),
      };

      return this.newAttachments.length > 0 || this.attachmentsToDelete.length > 0 || DataService.checkIfChanged(originalData, editedData);
    }
  },
  async mounted() {
    if (this.pscReport?.inspection?.id) {
      await this.getAttachments(1, this.pscReport, 'inspection.id');
    }
  },
  watch : {
    'pscReport.inspection.id': {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.getAttachments(1, this.pscReport, 'inspection.id');
        }
      }
    },
    toEdit () {
      this.$store.commit('SET_TO_EDIT', this.toEdit);
    }
  }

}
</script>

<style scoped>
table td {
  padding: 2px !important;
}
::v-deep .pre-wrap-txt.textarea-display-card p {
  margin-bottom: 0 !important;
}
</style>
